import { useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import ThemeProvider from "../../components/themeProvider";
import Navbar from "../../components/navbar";
import Home from "../home";
import Layout from "../layout";
import DashboardLayout from "../layout/dashboard";
import AnalyticsLayout from "../layout/analytics";
import AuthProvider from "../../components/authProvider";
import { SWRConfig } from "swr";
import { fetcher } from "../../state/axios";
import CompanyProvider from "../../components/companyProvider";
import { swrDefaultConfig } from "../../helpers/utils";
import TickerProvider from "../../components/tickerProvider";
import CacheProvider from "../../components/cacheProvider";
import BusinessSummaryLayout from "../../features/businessSummary/containers";
import ToastProvider from "../../components/toastProvider";
import CompanySwitchDialog from "../../features/multibrand/companySwitchDialog";
import AskVantageContainer from "../../features/askVantage/containers";
import AskVantageV2Container from "../../features/askVantageV2/containers";

import ReportLayout from "../../features/reports/components/reportLayout";
import MaintenanceBanner from "../../components/maintenanceBanner";
import { useSelector } from "react-redux";
import { RootState } from "../../state/store";
import ExportProvider from "../../features/exports/components/exportProvider";
import ExportHistory from "../../features/exports/components/exportHistory";
import SubRLayout from "../../features/subR/components/SubRLayout";
import SignalsDashboard from "../../features/signals/containers/SignalsDashboard";
import PromotionEngineDashboard from "../../features/promotionEngine/containers/PromotionEngineDashboard";
import RevenueLeakageDashboard from "../../features/revenueLeakage/containers/RevenueLeakageDashboard";
import WhatsNewModal from "../../components/whatsNewModal";

const App = () => {
  const { company_details } = useSelector((state: RootState) => state.company);
  const isMaintenance = company_details?.maintenance_mode?.enabled;
  const isDemoAccount = company_details?.demo_account;
  const isAskVantageEnabled = company_details?.ask_vantage_enabled;

  return (
    <ThemeProvider>
      <SWRConfig value={{ fetcher, ...swrDefaultConfig }}>
        <ToastProvider>
          <AuthProvider>
            <CompanySwitchDialog />
            <CompanyProvider>
              <WhatsNewModal />
              <MaintenanceBanner />
              <Navbar fixed="top" top={isMaintenance ? 60 : 0} />
              <TickerProvider>
                <ExportProvider>
                  <Routes>
                    <Route path="/signals" element={<SignalsDashboard />} />
                    <Route
                      path="/promotion-engine"
                      element={<PromotionEngineDashboard />}
                    />
                    <Route
                      path="/revenue-leakage"
                      element={<RevenueLeakageDashboard />}
                    />
                    <Route
                      path="/ask-vantage"
                      element={<AskVantageContainer />}
                    />
                    <Route
                      path="/ask"
                      element={<AskVantageV2Container />}
                    />
                    <Route
                      path="/business-summary"
                      element={<BusinessSummaryLayout />}
                    />
                    <Route path="/saved-reports" element={<ExportHistory />} />
                    <Route path="/" element={<Layout />}>
                      <Route index element={<Home />} />
                      <Route path=":dashboard" element={<DashboardLayout />} />
                      <Route
                        path=":dashboard/:widget"
                        element={<AnalyticsLayout />}
                      />
                      <Route
                        path=":dashboard/:widget/report"
                        element={<ReportLayout />}
                      />
                      <Route
                        path=":dashboard/:widget/report/:reportType"
                        element={<SubRLayout />}
                      />
                    </Route>
                  </Routes>
                </ExportProvider>
              </TickerProvider>
            </CompanyProvider>
          </AuthProvider>
        </ToastProvider>
      </SWRConfig>
    </ThemeProvider>
  );
};

export default App;
